import React from "react";
import hire1 from "../../Assets/hireItem1.png";
import hire2 from "../../Assets/hireItem2.png";
import hire3 from "../../Assets/hireItem3.png";
import hire4 from "../../Assets/hireItem4.png";

interface headerProps {
  header: string;
  desc: string;
}

export const Header = (props: headerProps) => {
  return (
    <div className="header">
      <div>
        <div className="left">
          <div className="header">{props.header}</div>
          <div className="desc">{props.desc}</div>
          <div className="buttons">
            <a href="https://api.whatsapp.com/send?phone=61488877505">Contact Us</a>
          </div>
        </div>
        <div className="right">
          <div className="title">Get Free Samples</div>
          <div className="input">
            <label>Name</label>
            <input placeholder="Enter your name" type="text" />
          </div>
          <div className="input">
            <label>Email</label>
            <input placeholder="Enter your email" type="text" />
          </div>
          <div className="input">
            <label>Phone</label>
            <input placeholder="Enter your phone" type="text" />
          </div>
          <div className="input">
            <label>Message</label>
            <textarea placeholder="Enter your message" />
          </div>
          <a href="https://api.whatsapp.com/send?phone=61488877505">Get Samples</a>
        </div>
      </div>
    </div>
  );
};

interface hireItemProps {
  img: string;
  heading: string;
  desc: string;
}
const HireItem = (props: hireItemProps) => {
  return (
    <div className="item">
      <img src={props.img} alt="Icon" />
      <div className="header">{props.heading}</div>
      <div className="desc">{props.desc}</div>
    </div>
  );
};

export const Hire = () => {
  return (
    <div className="hire">
      <div>
        <div className="left">
          <div className="header">Factors to consider before choosing a CDR writer</div>
          <div className="desc">
            We are renowned as Australia’s most successful CDR writing, RPL writing and KA02 writing service provider. The intellectual team of professional Writers, Experts,
            Engineers, IT Specialists, etc. provides high-quality CDR Services to the applicants. We help applicants from around the globe who want to migrate to Australia as a
            skilled workforce.
          </div>
          <div className="desc">
            Our team of writers possess many years of experience in this field and are highly qualified personnel. We have almost a 97% success rate until now. We guarantee an
            excellent quality CDR Report with original content.
          </div>
          <a href="https://api.whatsapp.com/send?phone=61488877505">Check Samples</a>
        </div>
        <div className="right">
          <HireItem
            img={hire1}
            heading="Skilled Specialized Writers"
            desc="Seasoned writers available to deliver a completely original, plagiarism-free report tailored to your needs."
          />
          <HireItem img={hire2} heading="97% Approval Rate" desc="Leading service provider ensuring successful report approval from EA." />
          <HireItem img={hire3} heading="On time delivery" desc="Well-structured and properly formatted CDR report delivered on time." />
          <HireItem img={hire4} heading="Reasonable Price" desc="Authentic content crafted according to all provided guidelines, offered at an affordable price." />
        </div>
      </div>
    </div>
  );
};

export const Contact = () => {
  return (
    <div className="contact">
      <div>
        <div className="top">Have a question? Give us a call on</div>
        <div className="phone">+61 488 877 505</div>
        <div className="desc">Interested in learning about our services? Enjoy a free consultation on migration skill assessments and connect directly with our experts.</div>
        <a href="https://api.whatsapp.com/send?phone=61488877505">Chat with us</a>
      </div>
    </div>
  );
};

interface ANZSCOItemProps {
  title: string;
  code: string;
  img: string;
}
export const ANZSCOItem = (props: ANZSCOItemProps) => {
  return (
    <div>
      <div className="img" style={{ background: `url(${props.img})` }} />
      <div>{props.title}</div>
      <div>{props.code}</div>
    </div>
  );
};
